export default "__VITE_ASSET__Jgml$GpB__$_?component__"